import React from "react";

function TableFuel({ listFuel }) {
  return (
    <table className="table table-striped">
      <thead>
        <tr>
          <th>Data</th>
          <th>Responsável</th>
          <th>Combustível</th>
          <th>Quantidade</th>
        </tr>
      </thead>
      <tbody>
        {listFuel.map((item, index) => (
          <tr key={index}>
            <td>{item.date}</td>
            <td>{item.responsible}</td>
            <td>{item.type}</td>
            <td>{item.quantity}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default TableFuel;
